var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubberEditorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    opacity: 0.05,
    cx: 28.723,
    cy: 27.7445,
    r: 27.7445,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Erase",
    d: "M34.1062 15.4496L41.0179 22.3612C42.2402 23.5835 42.2402 25.5653 41.0179 26.7876L28.9407 38.8629L37.4234 38.8632C37.9516 38.8632 38.3881 39.2557 38.4572 39.7649L38.4667 39.9065C38.4667 40.4347 38.0742 40.8712 37.565 40.9403L37.4234 40.9498L25.7244 40.9515C24.8672 40.9983 23.9944 40.6943 23.3396 40.0395L16.428 33.1278C15.2057 31.9055 15.2057 29.9237 16.428 28.7014L29.6798 15.4496C30.9021 14.2273 32.8839 14.2273 34.1062 15.4496ZM19.971 28.107L17.9034 30.1769C17.496 30.5843 17.496 31.2449 17.9034 31.6524L24.8151 38.564C25.0188 38.7677 25.2858 38.8696 25.5528 38.8696L25.593 38.8632L25.6465 38.8654C25.8815 38.8443 26.1107 38.7438 26.2905 38.564L28.3579 36.4953L19.971 28.107ZM31.1553 16.925L21.447 26.6311L29.8338 35.0193L39.5424 25.3121C39.9498 24.9047 39.9498 24.2441 39.5424 23.8367L32.6308 16.925C32.2233 16.5176 31.5627 16.5176 31.1553 16.925Z",
    fill: "#323232"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubberEditorIcon);
export default __webpack_public_path__ + "static/media/rubberEditorIcon.54aa8324cc19f24b39e62890813ccbb9.svg";
export { ForwardRef as ReactComponent };